/** The app shell: the top bar, the tabs across the top, search (ADR 0325). */
export const shell: Readonly<Record<string, string>> = {
  // The top bar
  "+ New Lead": "+ Nuevo prospecto",
  "Search name, address, phone, job #…":
    "Buscar nombre, dirección, teléfono, nº de trabajo…",
  Customers: "Clientes",
  Jobs: "Trabajos",
  "1 job": "1 trabajo",
  "{n} jobs": "{n} trabajos",
  "Sign out": "Cerrar sesión",
  "Could not load": "No se pudo cargar",

  // The tabs across the top (NAV_ITEMS in packages/core)
  Contacts: "Contactos",
  Prospects: "Prospectos",
  Ongoing: "En curso",
  Payouts: "Pagos a cuadrillas",
  Cal: "Calendario",
  Phone: "Teléfono",
  Partners: "Socios",
  Reports: "Informes",
  "AI Team": "Equipo IA",
  Marketing: "Marketing",
  Tools: "Herramientas",

  // The row of tabs beneath
  All: "Todos",
  "{name} · Closing": "{name} · Cierre",
  "Master (Sold)": "Maestro (Vendidos)",

  // My list (TaskList)
  "My list, {n} due": "Mi lista, {n} pendientes",
  "My list": "Mi lista",
  "{n} due": "{n} pendientes",
  "nothing due": "nada pendiente",
  Cancel: "Cancelar",
  "+ Add": "+ Agregar",
  "Reading your jobs…": "Leyendo los trabajos…",
  "Nothing owed. Every job of yours has been worked.":
    "Nada pendiente. Todos los trabajos están atendidos.",
  "Needs you now": "Atender ahora",
  "When you can": "Cuando se pueda",
  "Done today": "Hecho hoy",
  "Undo {title}": "Deshacer {title}",
  "Done: {title}": "Listo: {title}",
  "Put this off for a week": "Posponer una semana",
  "Snooze {title}": "Posponer {title}",
  Later: "Más tarde",
  "from {name}": "de {name}",
  "due {date}": "vence {date}",
  "Unknown contact": "Contacto desconocido",
  "Text unavailable": "Mensaje no disponible",
  "View contact": "Ver contacto",
  "Choose the text's job": "Elegir el trabajo del mensaje",
  "Choose job": "Elegir trabajo",
  Attach: "Vincular",
  "No available job on this contact. Review and dismiss this task if appropriate.":
    "Este contacto no tiene ningún trabajo disponible. Revisar y descartar esta tarea si corresponde.",
  "What needs doing?": "¿Qué hay que hacer?",
  "Who it is for": "Para quién es",
  Me: "Yo",
  "Due date": "Fecha límite",
  "Saving…": "Guardando…",
  Add: "Agregar",

  // What the app itself writes on a task (derivedTasks in packages/core).
  // Only the lines with no name in them can match; a title such as
  // "Call Craig Hurst" carries the customer and stays as written.
  "Never called": "Nunca se ha llamado",
  "You set this for today": "Programado para hoy",
  Tomorrow: "Mañana",
  "Sold, but no signed date — it counts in no month":
    "Vendido, pero sin fecha de firma — no cuenta en ningún mes",
  "Signed, but the stage never moved": "Firmado, pero la etapa nunca cambió",
  "Work is going ahead and nobody has signed it":
    "El trabajo sigue adelante y nadie lo ha firmado",
  "Promised terms the contract doesn’t show":
    "Términos prometidos que el contrato no muestra",
  "Prepared, never sent": "Preparada, nunca enviada",
  "Work orders exist, none is scheduled":
    "Hay órdenes de trabajo, ninguna programada",
  "In production with no work orders": "En producción sin órdenes de trabajo",
  "In a note": "En una nota",
  "Replied by email": "Respondió por email",
  "(no subject)": "(sin asunto)",
  "No material order on the active estimate":
    "Sin orden de materiales en el presupuesto activo",
  "Built, never placed": "Armada, nunca enviada",

  // The colour and theme buttons (SCENTS and THEME_LABEL in packages/core)
  "Colours: {name}. Pick your own.": "Colores: {name}. Elegir otros.",
  "Pick your colours": "Elegir colores",
  "My colours": "Mis colores",
  "Only you see them": "Nadie más los ve",
  "Roof Board": "Roof Board",
  Rosewater: "Agua de rosas",
  Jasmine: "Jazmín",
  Bergamot: "Bergamota",
  Vanilla: "Vainilla",
  "The company look": "El estilo de la empresa",
  "Soft pink with a deep rose edge": "Rosa suave con un borde rosa intenso",
  "Lavender and white petals": "Lavanda y pétalos blancos",
  "Warm amber on sunlit paper": "Ámbar cálido sobre papel al sol",
  "Cream and gold; black and gold after dark":
    "Crema y dorado; negro y dorado de noche",
  "Theme: {current}. Switch to {next}.": "Tema: {current}. Cambiar a {next}.",
  "Match my phone": "Igual que el teléfono",
  Light: "Claro",
  Dark: "Oscuro",

  // The banners along the bottom
  "Your login is not linked to a staff record yet.":
    "Esta cuenta aún no está vinculada a un registro de personal.",
  "Turn on notifications for this device?":
    "¿Activar las notificaciones en este dispositivo?",
  "Asking…": "Solicitando…",
  "Turn on": "Activar",
  "Not now": "Ahora no",
  "Install Roof Board on this device.":
    "Instalar Roof Board en este dispositivo.",
  Install: "Instalar",
  "To install: tap Share, then “Add to Home Screen”. Notifications need this.":
    "Para instalar: Compartir, luego “Agregar a pantalla de inicio”. Las notificaciones lo necesitan.",
  "A new version of Roof Board is ready.":
    "Hay una nueva versión de Roof Board lista.",
  Reload: "Recargar",
  "Build version": "Versión de la compilación",
};
